import React, { useState, useEffect, Fragment, useRef } from 'react';
import { PageHeader } from '../../../../Common';
import {Grid} from '@material-ui/core';
import { EmployeeCropTableContent } from "../../../Common/Table/tableContent";
import services from '../services';
import $ from "jquery";
import authService from '../../../Common/services';
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { CSVLink } from "react-csv";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { PlukingChecklistReportSchemaObject } from '../EmployeeNormCardReportSchema';
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import _ from 'lodash';
import { saveAs } from 'file-saver';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';

import Paper from '@material-ui/core/Paper';

import '../../../Common/Table/table.css';
import TablePagination from '@material-ui/core/TablePagination';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {
    Box,
    Button,
    makeStyles,



} from '@material-ui/core';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    row: {
        marginTop: '1rem'
    },
    colorCancel: {
        backgroundColor: "red",
    },
    colorRecordAndNew: {
        backgroundColor: "#FFBE00"
    },
    colorRecord: {
        backgroundColor: "green",
    }

}));

const screenCode = 'EMPLOYEENORMCARDREPORT'

export function EmployeeNormCardReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [monthlyCollectionDetails, setMonthlyCollectionDetails] = useState({
        groupID: "0",
        estateID: "0",
        collectionPointID: "0",
        fromDate: "",
        toDate: "",
        regNumber: ""

    });
    const classes = useStyles();
    const [data, setdata] = useState([]);
    const [subNames, setSubNames] = useState([]);
    const [colName, setColName] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [collectionCategory, setCollectionCategory] = useState([]);

    const [csvHeaders, setCsvHeaders] = useState([]);
    const [limit, setLimit] = useState(10);
    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };

    const [page, setPage] = useState(0);

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const [selectedSearchValues, setSelectedSearchValues] = useState({

        group: "0",
        estate: "0",
        collectionPoint: "0",
        fromDate: "",
        toDate: "",
        regNumber: ""

    });
    const [summeryValues, setSummeryValues] = useState({
        full: 0,
        half: 0,
        bellow: 0
    });
    const [csvData, setCsvData] = useState([]);
    const DropdownChanges = Object.freeze({ "group": 1, "operationEntity": 2 })
    const [reportData, setReportData] = useState([]);
    const [errors, setErrors] = useState({});
    const [detailCard, setDetailCard] = useState([]);
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const schema = Joi.object(PlukingChecklistReportSchemaObject).options({ allowUnknown: true });
    const contentRowNames = ["date", "sessionName", "totalAmount"];

    const [rsmReportData, setRsmReportData] = useState([]);
    const [generalReportData, setGeneralRReportData] = useState([]);
    const [employeeData, setEmployeeData] = useState([]);

    const [isRecordsAvailable, setIsRecordsAvailable] = useState(false);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        setIsTableHide(false);
        createDataTable();
    }, [reportData]);

    useEffect(() => {
        if (monthlyCollectionDetails.operationEntityID > 0) {
            trackPromise(
                getCollectionCategoryForDropDown()
            )
            resetDropDowns(DropdownChanges.operationEntity);
        }
    }, [monthlyCollectionDetails.operationEntityID])


    useEffect(() => {
        if (monthlyCollectionDetails.estateID !== "0") {
            trackPromise(
                getCollectionPointsForDropDown()
            )
        }
    }, [monthlyCollectionDetails.estateID])

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown(),
        )
    }, [monthlyCollectionDetails.groupID])


    useEffect(() => {
        setIsTableHide(true);
    }, [monthlyCollectionDetails.regNumber]);

    function handleGroupChange(target) {
        validateInputs(target);

        setMonthlyCollectionDetails({
            ...monthlyCollectionDetails,
            groupID: target.value,
            estateID: "0",

        });
    }

    function handleEstateChange(target) {
        validateInputs(target);

        setMonthlyCollectionDetails({
            ...monthlyCollectionDetails,
            estateID: target.value,
        });
    }

    function handleDivisionChange(target) {
        validateInputs(target);
        setMonthlyCollectionDetails({
            ...monthlyCollectionDetails,
            collectionPointID: target.value,
        });
    }



    function handleFromDateChange(target) {
        validateInputs(target);

        setMonthlyCollectionDetails({
            ...monthlyCollectionDetails,
            fromDate: target.value
        });
    }

    function handleToDateChange(target) {
        validateInputs(target);

        setMonthlyCollectionDetails({
            ...monthlyCollectionDetails,
            toDate: target.value
        });
    }

    function handleregNumber(target) {
        validateInputs(target);

        setMonthlyCollectionDetails({
            ...monthlyCollectionDetails,
            regNumber: target.value
        });
    }

    function resetDropDowns(type) {
        if (type === DropdownChanges.operationEntity) {
            setMonthlyCollectionDetails({
                ...monthlyCollectionDetails,
                collectionPointID: "0",
            });
        } else if (type === DropdownChanges.group) {
            setMonthlyCollectionDetails({
                ...monthlyCollectionDetails,
                operationEntityID: "0",
                collectionPointID: "0",
            });
        }
    }

    function handleEmployeeTypeChange(target) {
        validateInputs(target);

        setMonthlyCollectionDetails({
            ...monthlyCollectionDetails,
            employeeType: target.value
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, PlukingChecklistReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWEMPLOYEENORMCARDREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setMonthlyCollectionDetails({
            ...monthlyCollectionDetails,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const data = await services.getEstatesByGroupID(monthlyCollectionDetails.groupID);
        setEstates(data);
    }

    async function getCollectionCategoryForDropDown() {
        const collectionCategory = await services.getCollectionCategoryByOperationEntityForDropDown(monthlyCollectionDetails.operationEntityID);
        setCollectionCategory(collectionCategory);
    }

    async function getCollectionPointsForDropDown() {
        const collectionPoint = await services.getCollectionPointsByOperationentityGroupID(monthlyCollectionDetails.estateID, monthlyCollectionDetails.groupID)
        setCollectionPoint(collectionPoint);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }


    async function handleSearch(e) {
        e.preventDefault();
        setIsTableHide(true);

        const errorMessages = validate(schema, monthlyCollectionDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;
        const result = await services.getReportData(monthlyCollectionDetails);
        setReportData(result);
        formatResult(result);


        getSelectedDropdownValuesForReport(monthlyCollectionDetails);


    }

    function formatResult(data) {
        var result = [];
        var totalOfAllrecords = 0;
        var names = [];
        var csvHeaders = [
            { label: "Date", value: "date" },
            

        ];
        data.forEach(x => {
           
            
            var sessionName = x.sessionName;
            var finalDate = x.date.split('T')[0]

            if (result.length === 0) {
                result.push({
                    [sessionName]: checkUndifind(x.totalAmount),
                    employeeID: parseInt(x.employeeID),
                    registrationNumber: x.registrationNumber,
                    firstName: x.firstName,
                    total: checkUndifind(x.totalAmount),
                    configurationValue: x.configurationValue,
                    fieldName: x.fieldName,
                    cashkilo: x.cashkilo,
                    date: finalDate
                });
                names.push(x.sessionName);
                csvHeaders.push({ label: x.sessionName, value: x.sessionName });
                totalOfAllrecords = totalOfAllrecords + parseFloat(x.totalAmount);
            } else {
                totalOfAllrecords = totalOfAllrecords + parseFloat(x.totalAmount);
                var duplicate = result.find(y => (y.date) == (x.date));
              

                var duplicateName = names.find(y => y === x.sessionName);
  
                if (!duplicateName) {
                    names.push(x.sessionName);
                    csvHeaders.push({ label: x.sessionName, value: x.sessionName });
                }

                if (duplicate) {
                    duplicate[sessionName] = checkUndifind(duplicate[sessionName]) + checkUndifind(x.totalAmount);
                    duplicate.registrationNumber = x.registrationNumber;
                    duplicate.firstName = x.firstName;
                    duplicate.configurationValue = x.configurationValue;
                    duplicate.fieldName = x.fieldName;
                    duplicate.total = checkUndifind(duplicate.total) + checkUndifind(x.totalAmount);
                    duplicate.date = finalDate;
                }
                 else {
                    result.push({
                        [sessionName]: checkUndifind(x.totalAmount),
                        date: (x.date),
                        registrationNumber: x.registrationNumber,
                        firstName: x.firstName,
                        total: checkUndifind(x.totalAmount),
                        configurationValue: x.configurationValue,
                        fieldName: x.fieldName,
                        cashkilo: x.cashkilo,
                        date: finalDate
                    });
                }
            }
        });
        names.sort((a, b) => a > b ? 1 : -1);

           csvHeaders.push({ label: "Total", value: "total" });      
            csvHeaders.push({ label: "Cash Kilo", value: "cashkilo" });
            csvHeaders.push({ label: "Signature", value: "" });
        var result2 = [];

        result.forEach(x => {
            names.forEach(y => {
                if (x[y]) {
                    result2.push({
                        property: y,
                        value: checkUndifind(x[y])
                    });

                }
            });
        });

        const result3 = result2.reduce((obj, el) => {

            obj[el.property] = (obj[el.property] || 0) + el.value;

            return obj;
        }, {});
        const result4 = result.filter(x => x.total >= x.configurationValue);
        const result5 = result.filter(x => x.total < x.configurationValue && x.total >= x.configurationValue / 2);
        const result6 = result.filter(x => x.total < (x.configurationValue / 2));
        let okTot = 0;
        let totMan = 0;
        result.forEach(x => {
            if ((parseFloat(x.total) < parseFloat(x.configurationValue) / 2)) {
                okTot = okTot + parseFloat(x.total);
            }
            else if ((parseFloat(x.total) - parseFloat(x.configurationValue)) < 0) {
                okTot = okTot + (parseFloat(x.total) - parseFloat(x.configurationValue) / 2)
            }
            else {
                okTot = okTot + (parseFloat(x.total) - parseFloat(x.configurationValue));
            }
            totMan = totMan + (parseFloat(x.total) < (parseFloat(x.configurationValue) / 2) ? 0 : (parseFloat(x.total) >= parseFloat(x.configurationValue)) ? 1 : 0.5);
        });

        setSummeryValues({
            ...summeryValues,
            full: result4.length,
            half: result5.length,
            bellow: result6.length,

        });

        setCsvHeaders(csvHeaders);
        setSubNames(names);
        setdata(result);
        setCsvData(result);
        setColName(names);
        

        var resultqqqq = Object.entries(result3);

        var temlArry = [];
        for (const key in resultqqqq) {
            temlArry.push({
                name: resultqqqq[key][0],
                value: resultqqqq[key][1]
            })
        }
        temlArry.sort((a, b) => a.name > b.name ? 1 : -1);
    }

    function checkUndifind(value) {
        if (value === undefined) {
            return 0;
        }
        else {
            return value;
        }
    }
    function createFile() {
        var settings = {
            sheetName: 'Employee Norm Card Report',
            fileName: 'EmployeeNormCardReport',
            writeOptions: {}
        }
        csvData.forEach(x => {
            x.cashkilo =(parseFloat( x.total) < parseFloat( x.configurationValue) / 2
            ? parseFloat( x.total).toFixed(2)
            : (parseFloat( x.total) - parseFloat( x.configurationValue) < 0
                ? (parseFloat( x.total) - parseFloat( x.configurationValue) / 2).toFixed(2)
                : (parseFloat( x.total) - parseFloat( x.configurationValue)).toFixed(2)))
        });

        var newArray1 = {
            date: "",
            
        }

        var copyOfCsv = _.cloneDeep(csvData)
        var newRow1 = {
            date: "Group :" + groups[monthlyCollectionDetails.groupID],
            date: "Operation Entity : " + estates[monthlyCollectionDetails.estateID],
        }
        var newRow2 = {
            date: "Collection Point :" + collectionPoint[monthlyCollectionDetails.collectionPointID],
            date: "Registration Number : " + monthlyCollectionDetails.regNumber,
        }
        var newRow3 = {
            date: "From Date : " + monthlyCollectionDetails.fromDate,
            date: "To Date : " + monthlyCollectionDetails.toDate,
        }  
        var newRow4 = {
            date: "Group :" + groups[monthlyCollectionDetails.groupID],
        } 
        var newRow5 = {
            date: "Collection Point :" + collectionPoint[monthlyCollectionDetails.collectionPointID],
           
        } 
        var newRow6 = {
            date: "From Date : " + monthlyCollectionDetails.fromDate,
        }     
        
        var newRow1 = {         
            date: "Group :" + groups[monthlyCollectionDetails.groupID],
        }
        var newRow2 = {
           date: "Operation Entity : " + estates[monthlyCollectionDetails.estateID],
           
        }
        var newRow3 = {
            date: "Collection Point :" + collectionPoint[monthlyCollectionDetails.collectionPointID],
        }  
        var newRow4 = {
            date: "Registration Number : " + monthlyCollectionDetails.regNumber,
        } 
        var newRow5 = {
             date: "To Date : " + monthlyCollectionDetails.toDate,         
        } 
        var newRow6 = {
            date: "From Date : " + monthlyCollectionDetails.fromDate,
        }       

        copyOfCsv.push(newArray1, {},newRow1, newRow2, newRow3,newRow4,newRow5,newRow6)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    function onCancelClick() {
        clearState();
    }


    function clearState() {

        setMonthlyCollectionDetails({
            fromDate: "",
            toDate: "",
            regNumber: "",
            employeeType: "0"
        });
        setIsTableHide(true);
        setErrors("");
    }


    function getSelectedDropdownValuesForReport(monthlyCollectionDetails) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[monthlyCollectionDetails.groupID],
            estate: estates[monthlyCollectionDetails.estateID],
            collectionPoint: collectionPoint[monthlyCollectionDetails.collectionPointID],
            toDate: monthlyCollectionDetails.toDate,
            fromDate: monthlyCollectionDetails.fromDate,
            regNumber: monthlyCollectionDetails.regNumber,
        })
    }

    function createDataTable() {
        if (monthlyCollectionDetails.regNumber !== "") {
            $('#example').DataTable({
                destroy: true
            });
        } else {
            $('#rsm').DataTable({
                destroy: true
            });
            $('#general').DataTable({
                destroy: true
            });
        }
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Employee Norm Card Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={monthlyCollectionDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="estateID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={monthlyCollectionDetails.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="collectionPointID">Collection point *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={monthlyCollectionDetails.collectionPointID}
                                            onChange={(e) => handleDivisionChange(e.target)}>
                                            <MenuItem value="0">--Select Collection point--</MenuItem>
                                            {generateDropDownMenu(collectionPoint)}
                                        </Select>
                                        {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md">
                                        <InputLabel shrink id="toDate">Registartion Number*</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="regNumber"
                                            name="regNumber"
                                            type="regNumber"
                                            onChange={(e) => handleregNumber(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["regNumber"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["regNumber"]}</FormHelperText>)}
                                    </div>
                                </div>

                                
                                <div className="row">
                                <Grid item md={3} xs={8}>
                                    <div className="col-md">
                                        <InputLabel shrink id="fromDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            onChange={(e) => handleFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["fromDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["fromDate"]}</FormHelperText>)}
                                    </div>
                                    </Grid>

                                    <Grid item md={3} xs={8}>
                                    <div className="col-md">
                                        <InputLabel shrink id="toDate">To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            onChange={(e) => handleToDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["toDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["toDate"]}</FormHelperText>)}
                                    </div>
                                </Grid>

                                </div>
                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, monthlyCollectionDetails)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <TableContainer component={Paper}>
                                    <div className="row alternative_cls bg-light  ">
                                        <div className="card-body width1" style={{ display: 'flex', justifyContent: 'space-around', marginBottom: '20px', marginTop: '20px' }}>
                                            {(
                                                <>
                                                </>
                                            )}
                                        </div>

                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        Date
                                                    </TableCell>
                                                    {colName.map((item) => (
                                                        <TableCell style={{ fontWeight: "bold" }} align='center'>
                                                            {item} (Kg)
                                                        </TableCell>
                                                    ))}
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        Total
                                                    </TableCell>
                                                    {
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                            Cash Kilo
                                                        </TableCell>}                                                   

                                                </TableRow>
                                            </TableHead>
                                            <TableBody>

                                                {data.map((row) => (
                                                    <TableRow key={row.regNumber}>
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>{moment(row.date).format('YYYY-MM-DD')}</TableCell>

                                                        {subNames.map((column) => {
                                                            const value = row[column];
                                                            return (
                                                                <TableCell align='right'>{value == undefined ? '-' : parseFloat(value).toFixed(2)}</TableCell>
                                                            );
                                                        })}
                                                        <TableCell align="center">{parseFloat(row.total).toFixed(2)}</TableCell>
                                                        
                                                        {
                                                        <TableCell align="center">{parseFloat(row.total) < parseFloat(row.configurationValue) / 2
                                                             ? parseFloat(row.total).toFixed(2)
                                                             : (parseFloat(row.total) - parseFloat(row.configurationValue) < 0
                                                                 ? (parseFloat(row.total) - parseFloat(row.configurationValue) / 2).toFixed(2)
                                                                 : (parseFloat(row.total) - parseFloat(row.configurationValue)).toFixed(2))}
                                                        </TableCell>
                                                
                                                        }
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>

                                        <div className="pt-2">
                                            <input
                                                type="button"
                                                className="btn btn-primary pull-left ml-2"
                                                value="Excel"
                                                onClick={createFile}
                                            />

                                            <ReactToPrint
                                                documentTitle={"Employee Crop Report"}
                                                trigger={() => <input
                                                    type="submit"
                                                    className="btn btn-primary pull-left ml-2"
                                                    value="PDF"

                                                />}
                                                content={() => componentRef.current}
                                            />
                                        </div>
                                        <div hidden={true}>
                                            <CreatePdf ref={componentRef}
                                                summeryValues={summeryValues}
                                                monthlyCollectionDetails={selectedSearchValues} contentRowNames={subNames} data={data}
                                                initialData={colName} />
                                        </div>
                                    </div>
                                </TableContainer>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}


